import React, { useEffect, useState, useRef } from "react";
import DataManagement from "../../components/DataManagement/DataManagement";
import Paper from "@material-ui/core/Paper";
import Card from "../../components/ConfigurationCards";
import { SearchField } from "../../components/DataManagementList/DataManagementList.styled";
import PortalModal from "../../Portals";
import { getStateLoginComplete } from "../LayoutHome/stateLogin";
import LobCreationForm from "../../components/LobCreationForm/LobCreationForm";
import {
  GeneralStyleIDM,
  CardsWrapperIDM,
  CardsContainerIDM,
  PolicyQueueListContainer,
  useStylesIDM,
} from "./InternalDataManagementContainer.styled";
import { useMutation, useLazyQuery } from "@apollo/client";
import {
  DOWNLOAD_USERS,
  LOBS_BY_CLIENT,
  USERS_ADVANCE_SEARCH,
  GET_LOBS,
  CURRENT_USER_INFO,
} from "../../GraphQL/Queries";
import ExportExcelFile from "../../components/ReportSurveyBlock/ExportExcelFile/ExportExcelFile";
import { NotificationManager } from "react-notifications";
import SearchIcon from "@material-ui/icons/Search";
import { Form } from "react-bootstrap";
import CreatePolicyComponent from "../../components/CreatePolicyComponent/CreatePolicyComponent";
import {
  CREATE_QUEUE,
  UPDATE_MAIN_POLICY,
  UPDATE_SUB_POLICY,
  UPDATE_QUEUE,
  CREATE_SUB_POLICY,
} from "../../GraphQL/Mutations";
import { clientPolicyIngsight } from "../../App";
import PolicyListContainer from "../PolicyListContainer/PolicyListContainer";
import QueueListContainer from "../QueueListContainer/QueueListContainer";
import { AntTab, AntTabs } from "../../helpers/antTabs";
import HeaderComponent from "../../components/Header/Header";
import { ReactComponent as SiteManagementHeaderIcon } from "../../assets/svg/site-management-header-logo.svg";
import ModalCreatePolicy from "../../components/ModalCreatePolicy/ModalCreatePolicy";
import ModalLoader from "../../components/ModalLoader/ModalLoader";
import { useHistory, useLocation } from "react-router-dom";
import { ROLES } from "../../util/RolesConstants";

const InternalDataManagementContainer = () => {
  const [selectedMenu, selectMenu] = useState(["lob", "LOBs"]);
  const classes = useStylesIDM();
  const [valueTab, setValueTab] = useState(0);
  const [formTrigger, setFormTrigger] = useState("");
  const [user] = useState(getStateLoginComplete());
  const [reloadRender, setReloadRender] = useState(false);
  const [name, setName] = useState("");
  const [lobSelected, setLobSelected] = useState([]);
  const [renderAgain, setRenderAgain] = useState(false);
  const [action, setAction] = useState("create");
  const [recordSelected, setSelectedRecord] = useState();
  const history = useHistory();
  const location = useLocation();
  const [updateMainPolicy] = useMutation(UPDATE_MAIN_POLICY, {
    client: clientPolicyIngsight,
  });
  const [updateSubPolicy] = useMutation(UPDATE_SUB_POLICY, {
    client: clientPolicyIngsight,
  });
  const [createSubPolicy] = useMutation(CREATE_SUB_POLICY, {
    client: clientPolicyIngsight,
  });
  const [updateQueue] = useMutation(UPDATE_QUEUE, {
    client: clientPolicyIngsight,
  });
  const [createQueue] = useMutation(CREATE_QUEUE, {
    client: clientPolicyIngsight,
  });

  /*To navigate to any specific tab*/
  useEffect(() => {
    if (location?.state?.tab) {
      selectMenu(["policies", "Policies"]);
      setValueTab(location.state.tab);
    }
  }, [location]);

  useEffect(() => {
    if (
      (selectedMenu[0] === "policies" && formTrigger === "") ||
      (selectedMenu[0] === "queues" && formTrigger === "")
    ) {
      setName("");
      setLobSelected([]);
      setAction("create");
    }
    if (
      (selectedMenu[0] !== "policies" && formTrigger === "policies") ||
      (selectedMenu[0] !== "queues" && formTrigger === "queues")
    ) {
      setFormTrigger("");
      setAction("create");
    }
  }, [selectedMenu, formTrigger]);

  const handleChange = (event, newValue) => {
    if (newValue === 0) selectMenu(["lob", "LOBs"]);
    if (newValue === 1) selectMenu(["location", "Location"]);
    if (newValue === 2) selectMenu(["policies", "Policies"]);
    if (newValue === 3) selectMenu(["queues", "Queues"]);
    setValueTab(newValue);
  };

  const rSearch = useRef();

  const [allLobs, setAllLobs] = useState();
  const [lobsByCountry, setLOBsByCountry] = useState();
  const [clientId] = useState(user.clientId);

  const [dataDownloadUsers, setDataDownloadUsers] = useState();

  const [selectedCountryIds] = useState([]);
  const [selectedStateIds] = useState([]);
  const [selectedCityIds] = useState([]);
  const [selectedSiteIds] = useState([]);
  const [setUsersAdvanceSearch] = useState();
  const [selectedLobIds] = useState([]);
  const [selectedRoleIds] = useState([]);
  const [selectedComoNonComo, setSelectedComoNonComo] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [showCreatePolicy, setShowCreatePolicy] = useState(false);
  const [usersCountryId, setUsersCountryId] = useState();
  const [showLoader, setShowLoader] = useState(false);
  const [runQueryUserInfo] = useLazyQuery(CURRENT_USER_INFO, {
    context: { clientName: "LinkUsers" },
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      if (data?.currentUser[0]?.userId) {
        let userDetail = data.currentUser[0];
        setUsersCountryId(userDetail.location.countryId);
      }
    },
  });

  const [runQueryLobs] = useLazyQuery(LOBS_BY_CLIENT, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let resultOfAllLobs = data.lobsByClient.map((element) => {
        return {
          value: element?.lobid,
          label: element?.name,
        };
      });
      setAllLobs(resultOfAllLobs);
    },
  });

  const [,] = useLazyQuery(DOWNLOAD_USERS, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      data.downloadUsers[0].users = data?.downloadUsers[0].users.map((x) => {
        const details = {};
        for (const property in x) {
          const value = x[property];
          if (!(value === null || value === undefined)) {
            details[property] = value;
          }
        }
        return details;
      });
      setDataDownloadUsers(data?.downloadUsers[0].users);
    },
  });

  const [runQueryUsersAdvanceSearch] = useLazyQuery(USERS_ADVANCE_SEARCH, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let resultOfUsersAdvanceSearch = data.usersAdvanceSearch.map(
        (element) => {
          return element;
        }
      );
      setUsersAdvanceSearch(resultOfUsersAdvanceSearch);
    },
  });

  const [runQueryLobsByCountry, { loading: loadingLObs }] = useLazyQuery(
    GET_LOBS,
    {
      fetchPolicy: "network-only",
      onCompleted: (res) => {
        let resultOfLobs = res?.lobsListByCountry?.map((element) => {
          return {
            value: element?.lobId,
            label: element?.lobName,
          };
        });
        setLOBsByCountry(resultOfLobs);
      },
    }
  );

  useEffect(() => {
    if (action === "edit" && selectedMenu[0] === "policies") {
      setFormTrigger("policies");
    } else if (action === "edit" && selectedMenu[0] === "queues") {
      setFormTrigger("queues");
    }
  }, [action]);

  useEffect(() => {
    handleUsersAdvanceSearch();
  }, [
    selectedCountryIds,
    selectedStateIds,
    selectedCityIds,
    selectedSiteIds,
    selectedRoleIds,
    selectedLobIds,
    selectedComoNonComo,
  ]);

  useEffect(() => {
    /* lobs list to display in create queue dropdown 
    if (clientId) {
      runQueryLobs({
        variables: { clientId: clientId },
        context: { clientName: "LinkUsers" },
      });
    }
    */
    /*Getting current user info for country admin and supervisor role */
    if (
      user.roleId === ROLES.COUNTRY_ADMIN ||
      user.roleId === ROLES.SUPERVISOR
    ) {
      runQueryUserInfo();
    }
  }, []);

  let handleChangeComoNoComo = (item) => {
    if (item.value === 1) {
      setSelectedComoNonComo(true);
    } else if (item.value === 2) {
      setSelectedComoNonComo(false);
    } else {
      setSelectedComoNonComo(null);
    }
  };

  let handleUsersAdvanceSearch = () => {
    if (selectedComoNonComo !== null) {
      runQueryUsersAdvanceSearch({
        variables: {
          clientId: clientId,
          countries: selectedCountryIds,
          states: selectedStateIds,
          cities: selectedCityIds,
          clientSite: selectedSiteIds,
          roles: selectedRoleIds,
          lobs: selectedLobIds,
          isCoMoUser: selectedComoNonComo,
        },
        context: { clientName: "LinkUsers" },
      });
    } else {
      runQueryUsersAdvanceSearch({
        variables: {
          clientId: clientId,
          countries: selectedCountryIds,
          states: selectedStateIds,
          cities: selectedCityIds,
          clientSite: selectedSiteIds,
          roles: selectedRoleIds,
          lobs: selectedLobIds,
        },
        context: { clientName: "LinkUsers" },
      });
    }
  };

  const getDataBySearch = () => {
    setSearchText(rSearch?.current?.value);
  };

  const applySearchOnBreak = () => {
    let timer;
    return function () {
      let context = this;
      clearTimeout(timer);
      timer = setTimeout(() => {
        getDataBySearch.apply(context, arguments);
      }, 500);
    };
  };

  const handleSearch = applySearchOnBreak();

  let showSelectedMenu = () => {
    switch (selectedMenu[0]) {
      case "lob":
        return (
          <Card
            iconplusactive={false}
            coloricon="#FFFFFF"
            colorBorder="#FFFFFF"
            icon="plus"
            code="lobCreate"
            title="Create LOB"
            subtitle="lob creation"
            footerText="Create new LOB now"
            setFormTrigger={setFormTrigger}
          />
        );
      case "location":
        return (
          <Card
            iconplusactive={false}
            isHidden={user.roleId === ROLES.SUPERVISOR ? true : false}
            coloricon="#FFFFFF"
            colorBorder="#FFFFFF"
            icon="plus"
            code="location"
            title="Create Location"
            subtitle="location creation"
            footerText="New location"
            setFormTrigger={setFormTrigger}
          />
        );
      case "policies":
        return (
          <>
            <CardsContainerIDM>
              <Card
                iconplusactive={false}
                coloricon="#FFFFFF"
                colorBorder="#FFFFFF"
                icon="plus"
                code="policies"
                title="Create Policy"
                subtitle="policy creation"
                footerText="policy"
                setFormTrigger={() => {
                  history.push("/CreatePolicy");
                }}
              />
              <div className="right-section">
                <SearchField>
                  <SearchIcon />
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    ref={rSearch}
                    onChange={handleSearch}
                  />
                </SearchField>
              </div>
            </CardsContainerIDM>
          </>
        );
      case "queues":
        return (
          <>
            <CardsContainerIDM>
              <Card
                iconplusactive={false}
                coloricon="#FFFFFF"
                colorBorder="#FFFFFF"
                icon="plus"
                code="queues"
                title="Create Queue"
                subtitle="queue creation"
                footerText="queue"
                setFormTrigger={handleFormTrigger}
              />
              <div className="right-section">
                <SearchField>
                  <SearchIcon />
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    ref={rSearch}
                    onChange={handleSearch}
                  />
                </SearchField>
              </div>
            </CardsContainerIDM>
          </>
        );
      default:
        break;
    }
  };

  const handleSelectChange = (e) => {
    setLobSelected(e.length ? e : []);
  };

  const handleTextFieldChange = (e) => {
    setName(e.target ? e.target.value : "");
  };

  const handleFormTrigger = (e) => {
    setName("");
    setLobSelected([]);
    setAction("create");
    setFormTrigger(e);
  };

  const handleAddSubPolicy = (record) => {
    if (record?.countryId) {
      runQueryLobsByCountry({
        variables: {
          countryId: record?.countryId,
        },
        context: { clientName: "LinkUsers" },
      });
    }
    setSelectedRecord(record);
    setName("");
    setLobSelected([]);
    setAction("create");
    setFormTrigger("policies");
  };

  const handleEdit = (record) => {
    if (record?.subPolicyName && record?.mainPolicy?.countryId) {
      runQueryLobsByCountry({
        variables: {
          countryId: record?.mainPolicy?.countryId,
        },
        context: { clientName: "LinkUsers" },
      });
    }
    setSelectedRecord(record);
    setName(record?.policyName || record?.subPolicyName);
    setLobSelected(
      record?.lobs?.map((e) => {
        return {
          label: e.name,
          value: e.lobid,
        };
      }) || null
    );
    setAction("edit");
  };
  const handleEditQueue = (record) => {
    setSelectedRecord(record);
    setName(record?.queueName);
    setLobSelected(
      record?.lobs.map((e) => {
        return {
          label: e.name,
          value: e.lobid,
        };
      })
    );
    setAction("edit");
  };

  const handleSave = () => {
    if (recordSelected?.idSubPolicy) {
      handleSaveSubPolicy();
    } else {
      if (lobSelected?.length > 0) {
        handleSaveNewSubPolicy();
      } else {
        handleSaveMainPolicy();
      }
    }
  };

  const handleSaveNewSubPolicy = () => {
    if (name.trim() !== "" && lobSelected.length > 0) {
      let lobIds = lobSelected.map((e) => e.value);
      if (action === "create") {
        setShowLoader(true);
        createSubPolicy({
          variables: {
            policyName: name,
            lobIds,
            mainPolicyId: recordSelected?.idMainPolicy,
          },
        })
          .then((res) => {
            if (res?.data?.createSubPolicy?.idSubPolicy) {
              NotificationManager.success("Sub Policy added successfully");
              setFormTrigger("");
              setSelectedRecord();
              setRenderAgain(!renderAgain);
            }
            setShowLoader(false);
          })
          .catch((error) => {
            const errorMessage = error.message.split("\n")[0];
            NotificationManager.error(errorMessage, "", 5000);

            setShowLoader(false);
          });
      }
    } else {
      NotificationManager.warning("Please fill the mandatory fields");
    }
  };

  const handleSaveSubPolicy = () => {
    if (name.trim() !== "" && lobSelected.length > 0) {
      let lobIds = lobSelected.map((e) => e.value);
      if (action === "edit") {
        setShowLoader(true);
        updateSubPolicy({
          variables: {
            policyName: name,
            lobIds,
            idPolicy: recordSelected?.idSubPolicy,
          },
        })
          .then((res) => {
            console.log(recordSelected)
            console.log(res)
            if (res?.data?.updateSubPolicy?.idSubPolicy) {
              NotificationManager.success("Sub Policy updated successfully");
              setFormTrigger("");
              if (recordSelected?.subPolicyName) {
                recordSelected.subPolicyName = name;
              }
              if (recordSelected?.lobs) {
                recordSelected.lobs = lobSelected.map((e) => {
                  return {
                    lobid: e.value,
                    name: e.label,
                  };
                });
              }
              setSelectedRecord();
            }
            setShowLoader(false);
          })
          .catch((error) => {
            console.log(error)
            const errorMessage = error.message.split("\n")[0];
            NotificationManager.error(errorMessage, "", 5000);

            setShowLoader(false);
          });
      }
    } else {
      NotificationManager.warning("Please fill the mandatory fields");
    }
  };

  const handleSaveMainPolicy = () => {
    if (name.trim() !== "") {
      if (action === "edit") {
        setShowLoader(true);
        updateMainPolicy({
          variables: {
            policyName: name,
            idPolicy: recordSelected?.idMainPolicy,
          },
        })
          .then((res) => {
            if (res?.data?.updateMainPolicy?.idMainPolicy) {
              NotificationManager.success("Policy updated successfully");
              setFormTrigger("");
              if (recordSelected?.policyName) {
                recordSelected.policyName = name;
              }
              setSelectedRecord();
            }
            setShowLoader(false);
          })
          .catch((error) => {
            const errorMessage = error.message.split("\n")[0];
            NotificationManager.error(errorMessage, "", 5000);
            setShowLoader(false);
          });
      }
    } else {
      NotificationManager.warning("Please fill the mandatory fields");
    }
  };

  const updateCreateQueue = () => {
    let lobIds = lobSelected.map((e) => e.value);
    setShowLoader(true);
    if (action === "edit") {
      updateQueue({
        variables: {
          queueName: name,
          lobIds,
          idQueue: recordSelected?.idQueue,
        },
      })
        .then((res) => {
          if (res?.data?.updateQueue?.idQueue) {
            NotificationManager.success("Queue updated successfully");
            setFormTrigger("");
            setRenderAgain(!renderAgain);
          } else {
            NotificationManager.error("Something went wrong in updating queue");
          }
          setShowLoader(false);
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);

          setShowLoader(false);
        });
    } else {
      createQueue({
        variables: {
          queueName: name,
          lobIds,
        },
      })
        .then((res) => {
          if (res?.data?.createQueue?.idQueue) {
            NotificationManager.success("Queue created successfully");
            setFormTrigger("");
            setRenderAgain(!renderAgain);
          } else {
            NotificationManager.error("Something went wrong in creating queue");
          }
          setShowLoader(true);
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);

          setShowLoader(true);
        });
    }
  };

  const handleSaveQueue = () => {
    if (name.trim() !== "" && lobSelected.length > 0) {
      updateCreateQueue();
    } else {
      NotificationManager.warning("Please fill the mandatory fields");
    }
  };

  const getFieldPolicyComponent = () => {
    if (action === "edit") {
      return recordSelected?.idSubPolicy ? "Sub Policy" : "Policy";
    } else {
      return "Sub Policy";
    }
  };

  return (
    <>
      <GeneralStyleIDM>
        <div className={classes.root}>
          <HeaderComponent
            Icon={SiteManagementHeaderIcon}
            text={"Site Management"}
          />
          {formTrigger !== "lobCreate" && formTrigger !== "lobUpdate" && (
            <Paper position="static">
              <AntTabs
                aria-label="Data Management"
                value={valueTab}
                onChange={handleChange}
                style={{ overflowX: "auto" }}
              >
                <AntTab label="LOBs" id="lob" />
                <AntTab label="Location" id="location" />
                <AntTab label="Policies" id="policies" />
                {/* <AntTab label="Queues" id="queues" /> */}
              </AntTabs>
            </Paper>
          )}

          {formTrigger !== "lobCreate" && formTrigger !== "lobUpdate" && (
            <CardsWrapperIDM className="pt-3 pb-2">
              {showSelectedMenu()}
            </CardsWrapperIDM>
          )}

          {formTrigger === "lobCreate" && selectedMenu[0] === "lob" && (
            <LobCreationForm
              user={user}
              setFormTrigger={setFormTrigger}
              reloadRender={reloadRender}
              setReloadRender={setReloadRender}
            />
          )}
          {(selectedMenu[0] === "lob" || selectedMenu[0] === "location") &&
            formTrigger !== "lobCreate" && (
              <DataManagement
                selectedMenu={selectedMenu}
                reloadRender={reloadRender}
                setReloadRender={setReloadRender}
                formTrigger={formTrigger}
                setFormTrigger={setFormTrigger}
                valueTab={valueTab}
              />
            )}
          {selectedMenu[0] === "policies" && (
            <PolicyQueueListContainer>
              {formTrigger == "policies" && (
                <CreatePolicyComponent
                  options={lobsByCountry}
                  handleSelectChange={handleSelectChange}
                  title={getFieldPolicyComponent()}
                  textFieldLabel={getFieldPolicyComponent()}
                  selectFieldLabel="LOB"
                  handleTextFieldChange={handleTextFieldChange}
                  handleSave={handleSave}
                  textValue={name}
                  selectedOptions={lobSelected}
                  action={action}
                  showCreate={setFormTrigger}
                />
              )}
              <PolicyListContainer
                user={user}
                renderAgain={renderAgain}
                setRenderAgain={setRenderAgain}
                searchText={searchText}
                setSearchText={setSearchText}
                handleEdit={handleEdit}
                handleAddSubPolicy={handleAddSubPolicy}
              />
            </PolicyQueueListContainer>
          )}
          {selectedMenu[0] === "queues" && (
            <PolicyQueueListContainer>
              {formTrigger == "queues" && (
                <CreatePolicyComponent
                  options={allLobs}
                  handleSelectChange={handleSelectChange}
                  title="Queue"
                  textFieldLabel="Queue"
                  selectFieldLabel="LOB"
                  handleTextFieldChange={handleTextFieldChange}
                  handleSave={handleSaveQueue}
                  textValue={name}
                  selectedOptions={lobSelected}
                  showCreate={setFormTrigger}
                  setTextValue={setName}
                  setSelectedOptions={setLobSelected}
                  recordSelected={recordSelected}
                  action={action}
                />
              )}
              <QueueListContainer
                renderAgain={renderAgain}
                setRenderAgain={setRenderAgain}
                searchText={searchText}
                setSearchText={setSearchText}
                handleEdit={handleEditQueue}
              />
            </PolicyQueueListContainer>
          )}
        </div>
        <ExportExcelFile
          data={dataDownloadUsers}
          nameFile={"downloaded-users "}
          withIcon={false}
        ></ExportExcelFile>
        {showCreatePolicy && (
          <PortalModal>
            <ModalCreatePolicy
              user={user}
              closeModal={setShowCreatePolicy}
              usersCountryId={usersCountryId}
            />
          </PortalModal>
        )}
        {(loadingLObs || showLoader) && <ModalLoader />}
      </GeneralStyleIDM>
    </>
  );
};

export default InternalDataManagementContainer;
